import { defineMessages } from 'react-intl';

export const messages: {
	closeButton: {
		defaultMessage: string;
		id: string;
	};
	contactSupportButton: {
		defaultMessage: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		id: string;
	};
	errorIconAlt: {
		defaultMessage: string;
		id: string;
	};
	heading: {
		defaultMessage: string;
		id: string;
	};
} = defineMessages({
	heading: {
		id: 'twc.xflow.modal.error.heading',
		defaultMessage: 'Looks like something went wrong',
		description:
			'Heading displayed on the error screen of the trial activation modal when an error occurs',
	},
	description: {
		id: 'twc.xflow.modal.error.description',
		defaultMessage:
			"We weren't able to start your trial. Try again later or contact our support team.",
		description:
			'Body text on the error screen of the trial activation modal explaining the failure and next steps',
	},
	closeButton: {
		id: 'twc.xflow.modal.error.close.button',
		defaultMessage: 'Close',
		description: 'Button label to close the error screen in the trial activation modal',
	},
	contactSupportButton: {
		id: 'twc.xflow.modal.error.contact.support.button',
		defaultMessage: 'Contact support',
		description: 'Button label on the error screen that links to the support team contact page',
	},
	errorIconAlt: {
		id: 'twc.xflow.modal.error.icon.alt',
		defaultMessage: 'Error icon',
		description: 'Alt text for the error icon shown on the trial activation error screen',
	},
});
